import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var UrgentIcon = function UrgentIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "UrgentIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.017 1c.394 0 .714.32.714.714v.711a.714.714 0 1 1-1.428 0v-.71c0-.395.32-.715.714-.715M3.034 3.055a.714.714 0 0 1 1.01.007l.49.498a.714.714 0 0 1-1.018 1.002l-.49-.498a.714.714 0 0 1 .008-1.01m9.965 0a.714.714 0 0 1 .008 1.01l-.49.497a.714.714 0 0 1-1.018-1.002l.49-.498A.714.714 0 0 1 13 3.055m-.094 5.06c0-.394.32-.714.714-.714h.7a.714.714 0 1 1 0 1.428h-.7a.714.714 0 0 1-.714-.714M1 8.115c0-.394.32-.714.714-.714h.7a.714.714 0 1 1 0 1.428h-.7A.714.714 0 0 1 1 8.115m7.016-1.65a1.91 1.91 0 0 0-1.912 1.913v2.568h3.824V8.378a1.91 1.91 0 0 0-1.912-1.913m3.34 4.525V8.378a3.34 3.34 0 1 0-6.68 0v2.612a1.7 1.7 0 0 0-1.313 1.655v.656c0 .939.76 1.7 1.7 1.7h5.908c.938 0 1.698-.761 1.698-1.7v-.656a1.7 1.7 0 0 0-1.313-1.655m-6.565 1.655c0-.15.122-.27.271-.27h5.909c.15 0 .27.12.27.27v.656a.27.27 0 0 1-.27.271H5.062a.27.27 0 0 1-.27-.27z",
      clipRule: "evenodd"
    })
  }));
};

export { UrgentIcon };
